import React, {FC, PropsWithChildren} from 'react';
import styled, {css} from 'styled-components';

import {hoverSelector} from '../../../../../libs/shared/helpers/src/browser/hoverHelpers';
import {Handler} from '../../../../../libs/shared/helpers/src/react/reactHelpers';
import {fonts, fontWeights} from '../../../../../libs/shared/ui/src/styles/fontStyles';
import {PaletteColorsEnum} from '../../../../../libs/shared/ui/src/styles/paletteModel';

/*
 * Props.
 */

interface ComposerSectionButtonProps {
  color?: PaletteColorsEnum;
  onClick?: Handler;
  hasHover?: boolean;
}

/*
 * Style.
 */

interface ButtonStyleProps {
  $color: PaletteColorsEnum;
  $hasHover?: boolean;
}

const StyledButtonDiv = styled.div<ButtonStyleProps>`
  visibility: hidden;
  ${hoverSelector} {
    visibility: visible;
  }

  height: 16px;
  min-width: 16px;
  border-radius: 8px;

  display: flex;
  align-items: center;
  padding: 0 7px;
  font-size: 12px;
  line-height: 16px;

  > svg {
    margin: 0 -5px;
  }

  color: ${(p) => p.theme.greys.white};
  background-color: ${(p) => p.theme.palette[p.$color].shade40};
  font-family: ${fonts.system};
  font-weight: ${fontWeights.medium};

  &:hover {
    ${(p) => hoverStyle(p)};
  }
  ${(p) => p.$hasHover && hoverStyle(p)};
`;

function hoverStyle(props: ButtonStyleProps) {
  return css`
    background-color: ${(p) => p.theme.palette[props.$color].shade50};
  `;
}

/*
 * Component.
 */

export const ComposerSectionButton: FC<PropsWithChildren<ComposerSectionButtonProps>> = (props) => (
  <StyledButtonDiv
    $color={props.color || PaletteColorsEnum.GREY}
    $hasHover={props.hasHover}
    role="button"
    onClick={props.onClick}
  >
    {props.children}
  </StyledButtonDiv>
);
